import React from "react";
import Testimoials from "./Testimonials";
import { Box, Heading, Text } from "@chakra-ui/react";
import Animated from "./AnimatedSection";

const TestimonialsSection = () => {
  return (
    <Animated>
      <Box id="team">
        <Animated>
          <Box mx="auto" textAlign="center" w="90%" py={{ base: 6, lg: 12 }}>
            <Heading color="white" fontSize={{ base: "26px", lg: "42px" }}>
              MEET OUR TEAM{" "}
            </Heading>
            <Text mt={2} color="white" w="90%" mx="auto">
            The group of people who dared to dream
            </Text>
          </Box>
        </Animated>
        <Testimoials></Testimoials>
      </Box>
    </Animated>
  );
};

export default TestimonialsSection;
